import {
  IManualExtendedData,
  isManualExtendedData,
  TransactionStatus,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

export class CancelManualTransaction
  implements ITransactionAction<IManualExtendedData>
{
  icon = 'cancel';
  label = 'Cancel';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isManualExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IManualExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(data, isManualExtendedData).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return transaction.status === TransactionStatus.Pending;
      })
    );
  }

  async do(data: ITransactionActionsData<IManualExtendedData>): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.cancel(
      data.invoice,
      data.latestTransaction,
      'Cancel Transaction'
    );
    this.inProgress$.next(false);
  }
}
